import React, { useMemo } from 'react';
import { IItemCreationHeader } from '~/Components';
import { CreationTabGeneralInfo } from '~/Components/Icons/products/CreationTabGeneralInfo';
import { CreationTabDetails } from '~/Components/Icons/products/CreationTabDetails';
import { Schedule } from '~/Components/Icons/Schedule';
import { Settings_2 } from '~/Components/Icons/Settings_2';
import { useTranslation } from 'react-i18next';
import { EventType } from '~/Models/DTO/Event.model';

export interface IUseEventCreateHeaders {
  isGeneralSectionDone?: boolean;
  isDetailsSectionDone?: boolean;
  isScheduleSectionDone?: boolean;
  isSettingsSectionDone?: boolean;
  eventType: EventType | void;
}

export const useEventCreateHeaders = ({
  isGeneralSectionDone = true,
  isDetailsSectionDone = true,
  isScheduleSectionDone = true,
  isSettingsSectionDone = true,
  eventType,
}: IUseEventCreateHeaders): IItemCreationHeader[] => {
  const { t } = useTranslation();

  const { createHeader, title } = useMemo(
    () => ({
      createHeader: (items: Omit<IItemCreationHeader, 'index'>[]) =>
        items.map((item, index) => ({ ...item, index })),
      title: {
        general: (isDone: boolean) => ({
          title: t('app.title.general'),
          icon: <CreationTabGeneralInfo />,
          testId: 'eventTab.generalInfo',
          isDone,
        }),
        details: (isDone: boolean) => ({
          title: t('app.title.details'),
          icon: <CreationTabDetails />,
          testId: 'eventTab.details',
          isDone,
        }),
        schedule: (isDone: boolean) => ({
          title: t('app.title.schedule'),
          icon: <Schedule />,
          testId: 'eventTab.schedule',
          isDone,
        }),
        settings: (isDone: boolean) => ({
          title: t('app.settings'),
          icon: <Settings_2 />,
          testId: 'eventTab.settings',
          isDone,
        }),
      },
    }),
    [t],
  );

  if (!eventType) {
    return createHeader([title.general(isGeneralSectionDone)]);
  } else if (eventType === EventType.FREE_TRAINING) {
    return createHeader([
      title.general(isGeneralSectionDone),
      title.details(isDetailsSectionDone),
      title.schedule(isScheduleSectionDone),
    ]);
  }

  return createHeader([
    title.general(isGeneralSectionDone),
    title.details(isDetailsSectionDone),
    title.schedule(isScheduleSectionDone),
    title.settings(isSettingsSectionDone),
  ]);
};
